import CrossedOutPrice from './crossed-out-price'

export const AmuiCrossedOutPrice = CrossedOutPrice

export default Vue => Vue.component(CrossedOutPrice.name, CrossedOutPrice)
